import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { Room, RoomEvent, Track } from 'livekit-client';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.css']
})
export class ViewerComponent implements OnInit, OnDestroy {
  @ViewChild('remoteContainer') remoteContainerRef!: ElementRef<HTMLDivElement>;
  hasStream = false;
  audioBlocked = false;
  loading = true;
  ended = false;
  error = '';
  private room?: Room;

  constructor(private http: HttpClient, private route: ActivatedRoute) {}

  async ngOnInit() {
    const token = this.route.snapshot.paramMap.get('token');
    try {
      const res: any = await firstValueFrom(
        this.http.post(`${environment.apiUrl}live/${token}/viewer-token`, {})
      );

      const room = (this.room = new Room());
      room.on(RoomEvent.TrackSubscribed, (track: Track) => this.attach(track));
      room.on(RoomEvent.TrackUnsubscribed, (track: Track) => {
        track.detach().forEach(el => el.remove());
        this.hasStream = this.remoteContainerRef.nativeElement.querySelector('video') !== null;
      });
      room.on(RoomEvent.ParticipantDisconnected, () => {
        if (room.remoteParticipants.size === 0) this.ended = true;   // broadcaster chala gaya
      });
      room.on(RoomEvent.AudioPlaybackStatusChanged, () => (this.audioBlocked = !room.canPlaybackAudio));

      await room.connect(res.server_url, res.token);
      this.loading = false;

      room.remoteParticipants.forEach(p =>
        p.trackPublications.forEach(pub => { if (pub.track) this.attach(pub.track); })
      );
    } catch (e: any) {
      this.loading = false;
      this.error = e?.error?.message || 'This live link is invalid or has ended.';
    }
  }

  private attach(track: Track) {
    if (track.kind !== Track.Kind.Video && track.kind !== Track.Kind.Audio) return;
    if (document.getElementById(`track-${track.sid}`)) return;
    const el = track.attach();
    el.id = `track-${track.sid}`;
    this.remoteContainerRef.nativeElement.appendChild(el);
    if (track.kind === Track.Kind.Video) { this.hasStream = true; this.ended = false; }
  }

  enableSound() { this.room?.startAudio(); this.audioBlocked = false; }

  ngOnDestroy() { this.room?.disconnect(); }
}